import { render, staticRenderFns } from "./AdminEditIM.vue?vue&type=template&id=22ed6a79&lang=pug&"
import script from "./AdminEditIM.vue?vue&type=script&lang=js&"
export * from "./AdminEditIM.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditIM.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports